export default (type: string) => {
    switch (type) {
    case 'issue':
        return 'error';
    default:
        return undefined;
    }
};
